import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore";
let FillIn = class FillIn extends Vue {
  constructor() {
    super(...arguments);
    this.answer = "";
  }
  dataChage(value) {
    this.zItem = value;
    if (this.viewMode == "ANSWERREVIEW") {
      if (value.answer) {
        this.answer = value.answer;
      }
    }
  }
  get questionnaireType() {
    return this.businessType || QuestionnaireEditModule.questionnaireType;
  }
};
__decorate([Prop({
  type: String,
  default: "EDIT"
})], FillIn.prototype, "viewMode", void 0);
__decorate([Prop({
  type: Number,
  default: 0
})], FillIn.prototype, "zIndex", void 0);
__decorate([Prop({
  type: Boolean,
  default: true
})], FillIn.prototype, "showScore", void 0);
__decorate([Prop({
  type: String,
  default: ""
})], FillIn.prototype, "businessType", void 0);
__decorate([Prop({
  type: Boolean,
  default: true
})], FillIn.prototype, "Required", void 0);
__decorate([Watch("zIndex", {
  immediate: true
})
// eslint-disable-next-line
// watchIndex() {}
, Prop({
  type: Object,
  default: {}
})], FillIn.prototype, "item", void 0);
__decorate([Watch("item", {
  immediate: true,
  deep: true
})], FillIn.prototype, "dataChage", null);
FillIn = __decorate([Component({
  name: "fillIn"
})], FillIn);
export default FillIn;